import { z } from 'zod';

const MetadataSchemaPotentialActionDTO = z
    .object({
        potentialAction: z
            .object({
                '@type': z.string(),
                target: z.string(),
                'query-input': z.string(),
            })
            .optional(),
    })
    .optional();

const MetadataSchemaLogoDTO = z
    .object({
        logo: z.string().optional(),
        contactPoint: z
            .object({
                '@type': z.string(),
                contactType: z.string(),
                telephone: z.string(),
                email: z.string().optional(),
            })
            .optional(),
    })
    .optional();

const MetadataSchemaSameAsDTO = z.object({
    sameAs: z.array(z.string()).optional(),
});

export const MetadataSchemaDTO = z
    .object({
        '@context': z.string(),
        '@type': z.string(),
        name: z.string(),
        url: z.string(),
        alternateName: z.string().optional(),
        legalName: z.string().optional(),
    })
    .and(MetadataSchemaPotentialActionDTO.and(MetadataSchemaLogoDTO).and(MetadataSchemaSameAsDTO));

export const MetaDataSEOByKeyDTO = z.object({
    title: z.string().optional(),
    description: z.string().optional(),
    keywords: z.string().optional(),
    openGraph: z
        .object({
            title: z.string().optional(),
            description: z.string().optional(),
            url: z.string().optional(),
            siteName: z.string(),
            type: z.string(),
            images: z
                .array(
                    z.object({
                        url: z.string(),
                    }),
                )
                .optional(),
        })
        .optional(),
    twitter: z
        .object({
            card: z.string(),
            title: z.string().optional(),
            description: z.string().optional(),
        })
        .optional(),
    verification: z
        .object({
            google: z.string(),
        })
        .optional(),
    alternates: z
        .object({
            canonical: z.string().optional(),
            languages: z.record(z.string()).optional(),
        })
        .optional(),
    httpsEquivs: z
        .array(
            z.object({
                httpEquiv: z.string(),
                content: z.string(),
            }),
        )
        .optional(),
    schemas: z.array(MetadataSchemaDTO).optional(),
    robots: z
        .object({
            index: z.boolean(),
            follow: z.boolean(),
            nocache: z.boolean(),
        })
        .optional(),
    appLinks: z
        .object({
            ios: z
                .object({
                    url: z.string(),
                    app_store_id: z.string(),
                })
                .optional(),
            android: z
                .object({
                    package: z.string(),
                    app_name: z.string(),
                })
                .optional(),
            web: z
                .object({
                    url: z.string(),
                    should_fallback: z.boolean(),
                })
                .optional(),
        })
        .optional(),
    alternatesLocales: z.array(z.string()).optional(),
});

export type MetaDataSEOByKeyDTO = z.infer<typeof MetaDataSEOByKeyDTO>;
